import React from "react";

const wrappedComponentCache = new WeakMap();

const getProviderCache = (Component) => {
  let providerCache = wrappedComponentCache.get(Component);

  if (!providerCache) {
    providerCache = new WeakMap();
    wrappedComponentCache.set(Component, providerCache);
  }

  return providerCache;
};

const wrapWithProviders = (Component, providers = []) => {
  const providerCache = getProviderCache(Component);
  const providerKey = Array.isArray(providers) ? providers : [];
  const cachedComponent = providerCache.get(providerKey);

  if (cachedComponent) {
    return cachedComponent;
  }

  const WrappedComponent = function WrappedWithProviders() {
    return providerKey.reduceRight((acc, Provider) => {
      return <Provider>{acc}</Provider>;
    }, <Component />);
  };

  WrappedComponent.displayName = `WrappedWithProviders(${
    Component.displayName || Component.name || "Component"
  })`;

  providerCache.set(providerKey, WrappedComponent);

  return WrappedComponent;
};

export default wrapWithProviders;
